<script setup lang="ts">
// "What changes the math" — condensed cards, each linking to the full guide
// on the sister site. Cross-pollination, not duplication.
const FACTORS = [
    {
        title: 'Refrigerant deadlines',
        body: 'R-22 recharges get pricier every year, R-410A is phasing down, and new systems use R-32/R-454B. "Just recharge it" is a subscription with a rising price.',
    },
    {
        title: 'SEER2 payback',
        body: 'Replacing a 10-SEER-era unit isn\'t just a cost — it\'s a $350–$450/yr bill cut for a typical 3-ton system. Efficiency is the tiebreaker, not the reason.',
    },
    {
        title: 'Right-sizing',
        body: 'Replacement is your one chance to fix a mis-sized system. Demand a Manual J load calculation on every quote — never a square-footage guess.',
        link: 'Why bigger isn\'t better',
    },
    {
        title: 'Humidity & comfort',
        body: 'Clammy at 74°F? The problem may be sizing, not settings. Target 30–50% indoor humidity — a right-sized modern system holds it effortlessly.',
    },
]
</script>

<template>
    <section id="factors" class="site-section band">
        <div class="site-content">
            <span class="kicker" v-reveal>Context</span>
            <h2 v-reveal>What changes the math</h2>
            <p class="muted intro">
                Four things that tip repair-vs-replace decisions more than people expect.
            </p>

            <div class="cards">
                <div v-for="(factor, i) in FACTORS" :key="factor.title" v-reveal="i * 80" class="card">
                    <h3>{{ factor.title }}</h3>
                    <p class="muted">{{ factor.body }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.band {
    background-color: var(--site-bg-alt);
    background-image: var(--site-pattern, none);
}

.intro {
    max-width: 42rem;
}

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--site-space-md);
    margin-top: var(--site-space-lg);
}

.card {
    display: flex;
    flex-direction: column;
    gap: var(--site-space-sm);
    padding: var(--site-space-lg);
    background: var(--site-surface);
    border: 2px solid var(--site-border);
    border-radius: var(--site-radius-md);
    color: var(--site-text);

    h3 {
        font-size: 1.02rem;
        margin: 0;
    }

    p {
        font-size: 0.92rem;
        margin: 0;
        flex: 1;
    }
}
</style>
